import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { mBank } from "@mbank-design/design-system/themes";
import { DesignSystemThemeProvider } from "@mbank-design/design-system/providers";
import { GlobalStyles } from "@mbank-design/design-system/styles";
import { App } from "./App";

const rootElement = document.getElementById("root") as HTMLElement;
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <DesignSystemThemeProvider theme={mBank}>
            <GlobalStyles/>
            <App/>
        </DesignSystemThemeProvider>
    </BrowserRouter>, rootElement
);
